import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (p930h)
// ============================================================

export interface F90H {
  f90h_01: string | null; // 行事曆日期 (DATE, PK)
  f90h_11: string;        // 事件代碼或類型碼
  f90h_12: number;        // 事件類型數值
  f90h_13: string;        // 簡碼或分類碼
  f90h_14: string;        // 事件名稱/描述
  f90h_15: string;        // 詳細說明 (MEMO)
  f90h_21: string;        // 相關代碼1
  f90h_22: string;        // 相關代碼2
  f90h_23: string;        // 相關代碼3
  f90h_24: string;        // 相關代碼4
  f90h_91: string;        // 建立/異動人員代碼
  f90h_92: string | null; // 建立/異動日期
  f90h_93: string;        // 其他稽核欄位
}

// ============================================================
// Request / Response types
// ============================================================

export interface P930HListResponse {
  data: F90H[];
  total: number;
  page: number;
  size: number;
}

export interface P930HCreateRequest {
  f90h_01: string; // YYYY-MM-DD
  f90h_11: string;
  f90h_12?: number | null;
  f90h_13: string;
  f90h_14: string;
  f90h_15: string;
  f90h_21: string;
  f90h_22: string;
  f90h_23: string;
  f90h_24: string;
}

export interface P930HUpdateRequest {
  f90h_11: string;
  f90h_12?: number | null;
  f90h_13: string;
  f90h_14: string;
  f90h_15: string;
  f90h_21: string;
  f90h_22: string;
  f90h_23: string;
  f90h_24: string;
}

export interface CalendarQueryRequest {
  year: number;
  month: number;
  mode: number; // 1=single month (42 days), 2=cross-month (3 months)
}

export interface CalendarQueryResponse {
  data: F90H[];
  total: number;
}

export interface ValidationError {
  field: string;
  rule: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const p930hApi = {
  async list(page = 1, size = 20, keyword?: string): Promise<P930HListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/p930h', { params });
    return res.data;
  },

  async get(dateStr: string): Promise<F90H> {
    const res = await apiClient.get(`/api/p930h/${encodeURIComponent(dateStr)}`);
    return res.data;
  },

  async create(data: P930HCreateRequest): Promise<F90H> {
    const res = await apiClient.post('/api/p930h', data);
    return res.data;
  },

  async update(dateStr: string, data: P930HUpdateRequest): Promise<F90H> {
    const res = await apiClient.put(`/api/p930h/${encodeURIComponent(dateStr)}`, data);
    return res.data;
  },

  async delete(dateStr: string): Promise<void> {
    await apiClient.delete(`/api/p930h/${encodeURIComponent(dateStr)}`);
  },

  async queryCalendar(params: CalendarQueryRequest): Promise<CalendarQueryResponse> {
    const res = await apiClient.post('/api/p930h/query', params);
    return res.data;
  },
};
